import { render } from "./UserFiliaisContext.vue?vue&type=template&id=270c0d70"
import script from "./UserFiliaisContext.vue?vue&type=script&lang=js"
export * from "./UserFiliaisContext.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__